export const ajax = axios.create({
  // baseURL: /localhost/.test(location.host) || !/[a-z]/.test(location.host) ? "/api" : ""
  baseURL: /localhost/.test(location.host) ? "/api" : ""
});
